import { HeaderMenuItem } from "./header-menu-item";
import type { HeaderMenu } from "./header-menu";
import { HeaderLeagueNavigation } from "./header-league-navigation";

import { FeatureLink } from "@softmax/web-features/navigation";

import { buildHref } from "@softmax/web-addresses";

import { useOnboardingOpen } from "@softmax/web-features/site";

import {
  leaguesUrl,
  getStartedLink,
  type SiteLink,
} from "@softmax/web-features/site/records";

import type { PillMenuData } from "../use-pill-menu";

import type { SiteHeaderControls } from "../use-site-header";

import { isNavigationClick } from "../link-click";

import joinedStyles from "../account-pill.module.css";

import { MenuItem } from "../menu/menu-item";
import { MenuGroup } from "../menu/menu-group";

export function SiteHeaderNavigation({
  data,
  member,
  leagues,
  ids,
  panel,
  hydrated,
  setPanel,
  onNavigate,
  disclosure,
}: Pick<
  SiteHeaderControls,
  "ids" | "panel" | "setPanel" | "onNavigate" | "disclosure"
> & {
  data: PillMenuData;
  member: boolean;
  leagues: SiteLink[];
  hydrated: boolean;
}) {
  const onboardingOpen = useOnboardingOpen();
  const menus: HeaderMenu[] = [
    { key: "browse", heading: "Browse", href: leaguesUrl, links: leagues },
    // Signed out, Get Started is the header's action.
    ...(onboardingOpen
      ? [
          {
            key: "get-started",
            heading: getStartedLink.label,
            href: getStartedLink.href,
            links: [],
          },
        ]
      : []),
  ];

  const policies = { label: "Policies", href: buildHref({ name: "policies" }) };
  return (
    <>
      <HeaderLeagueNavigation
        data={data}
        member={member}
        onNavigate={onNavigate}
      />
      <nav aria-label="Softmax" className={joinedStyles.nav}>
        <button className={joinedStyles.navToggle} {...disclosure("nav")}>
          Menu
        </button>
        <ul className={joinedStyles.links}>
          {menus.map((menu) => (
            <HeaderMenuItem
              key={menu.key}
              menu={menu}
              ids={ids}
              panel={panel}
              hydrated={hydrated}
              onNavigate={onNavigate}
              setPanel={setPanel}
            />
          ))}
          {member && !data.coworld && (
            <li className={joinedStyles.slot}>
              <FeatureLink
                href={policies.href}
                className={joinedStyles.link}
                onClick={(event) => {
                  if (isNavigationClick(event)) onNavigate(policies.href);
                }}
              >
                {policies.label}
              </FeatureLink>
            </li>
          )}
        </ul>
        {panel === "nav" && (
          <ul
            id={`${ids}-nav`}
            className={`${joinedStyles.menu} ${joinedStyles.panel}`}
            aria-label="Menu"
          >
            {menus.map((menu) =>
              menu.href && menu.links.length === 0 ? (
                <MenuItem
                  key={menu.key}
                  link={{ label: menu.heading, href: menu.href }}
                  styles={joinedStyles}
                  onNavigate={onNavigate}
                />
              ) : (
                <MenuGroup
                  key={menu.key}
                  heading={menu.heading}
                  links={menu.links}
                  styles={joinedStyles}
                  onNavigate={onNavigate}
                />
              ),
            )}
            {member && !data.coworld && (
              <MenuGroup
                heading="Softmax"
                links={[policies]}
                styles={joinedStyles}
                onNavigate={onNavigate}
              />
            )}
          </ul>
        )}
      </nav>
    </>
  );
}
